import React from 'react';
import { Link } from 'react-router-dom';
import { Home as HomeIcon, Search, ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-habita-cream flex flex-col items-center justify-center p-6 text-center">
      <SEO title="Página no encontrada" noindex />
      <div className="max-w-lg">
        <p className="font-serif text-[140px] lg:text-[200px] font-bold text-habita leading-none">404</p>
        <h1 className="font-serif text-3xl lg:text-4xl font-bold text-habita-dark mt-2">Esta página no existe</h1>
        <p className="text-gray-600 mt-4">La dirección que buscas no está disponible o la propiedad fue retirada.</p>
        <div className="mt-8 flex gap-3 justify-center flex-wrap">
          <Link to="/" className="btn-habita inline-flex items-center gap-2 px-7 h-12 rounded-full font-semibold"><HomeIcon className="w-4 h-4" /> Ir al inicio</Link>
          <Link to="/buscar" className="inline-flex items-center gap-2 px-7 h-12 rounded-full font-semibold border border-gray-200 text-gray-700 hover:bg-gray-50"><Search className="w-4 h-4" /> Buscar propiedades</Link>
        </div>
      </div>
    </div>
  );
}
